import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MapControls } from '../../utilities/MapControls/MapConrols';
import { Trip } from '../../DataStructures/Trip/Trip';
import { DirectionsService } from '../../utilities/DirectionsService/DirectionsService';
import { Router } from '@angular/router';
import { ReportLine } from '../../DataStructures/TripReport/TripReport';
import { Location } from '@angular/common';

@Component({
  selector: 'app-view-trip-route',
  templateUrl: './view-trip-route.component.html',
  styleUrls: ['./view-trip-route.component.css']
})
export class ViewTripRouteComponent implements OnInit, AfterViewInit {

  @ViewChild('map') mapReference: ElementRef;
  jaLat = 18.1350138;
  jaLng = -77.1981928;
  directionsMarkers = [];
  trip:Trip;
  position;
  reportLine:ReportLine;
  constructor(private directions:DirectionsService, public mapControls: MapControls, private location:Location) { }

  back(){
    this.location.back();
    //this.router.navigate(['/user-portal/account']);
  }
  ngAfterViewInit(): void {
    this.mapControls.initialize(this.mapReference);
    this.mapControls.createMapAndCenterOnLoaction(this.jaLat, this.jaLng, true, false);
    this.mapControls.map.setZoom(7);
    let tripJson = localStorage.getItem('viewtrip');
    let lineJson = localStorage.getItem('reportline');
    if(tripJson){
      try{
        this.reportLine = JSON.parse(lineJson);
        this.trip = Trip.createTripFromRawTripData(JSON.parse(tripJson));
        let login = JSON.parse(localStorage.getItem('login'));
        let area = this.trip.areas.find(x => x.userid == login.payload.userId);
        let index = this.trip.areas.indexOf(area);
        this.position = ( index + 2 );
        this.viewRoundTrip(this.trip);
      }catch(e){

      }
    }

  }

  ngOnInit() {

  }

  viewRoundTrip(trip: Trip, ordered = true) {
    trip.getDirectionsGoogle(this.directions, {
      avoidTolls: true,
      orderwaypoints: ordered,
      splitDirections: true
    }).then(res => {
      this.showTripOnMap(res);
    }).catch(e => {
      alert("Error getting directions:" + e);
    })
  }

  private showTripOnMap(trip: Trip) {

    this.mapControls.clearMarkers();
    this.mapControls.directionsDisplay.setDirections(trip.legs[trip.currentLegIndex]);
    this.directionsMarkers = this.mapControls.addDirectionsMarkers(trip, null);

  }

}
